export let colorMap = {
  'geel': '#ffcc00',
  'geelVergrijsd': '#e1b600',
  'oranje': '#f39200',
  'oranjeVergrijsd': '#ce7c00',
  'rood': '#e94c0a',
  'roodVergrijsd': '#b23d02',
  'roze': '#af0e80',
  'rozeVergrijsd': '#82045e',
  'donkerblauw': '#0058b8',
  'donkerblauwVergrijsd': '#163a72',
  'lichtblauw': '#00a1cd',
  'lichtblauwVergrijsd': '#0581a2',
  'grasgroen': '#53a31d',
  'grasgroenVergrijsd': '#488225',
  'appelgroen': '#afcb05',
  'appelgroenVergrijsd': '#899d0c',
  'grijsLicht' : '#f2f2f2',
  'grijsDonker' : '#7f7f7f',
};

export let colorListPairs = [
  {
    'key': 'lichtblauw',
    'label': 'Lichtblauw',
    'value': [colorMap.lichtblauw, colorMap.lichtblauwVergrijsd],
  },
  {
    'key': 'donkerblauw',
    'label': 'Donkerblauw',
    'value': [colorMap.donkerblauw, colorMap.donkerblauwVergrijsd],
  },
  {
    'key': 'appelgroen',
    'label': 'Appelgroen',
    'value': [colorMap.appelgroen, colorMap.appelgroenVergrijsd],
  },
  {
    'key': 'grasgroen',
    'label': 'Grasgroen',
    'value': [colorMap.grasgroen, colorMap.grasgroenVergrijsd],
  },
  {
    'key': 'oranje',
    'label': 'Oranje',
    'value': [colorMap.oranje, colorMap.oranjeVergrijsd],
  },
  {
    'key': 'roze',
    'label': 'Roze',
    'value': [colorMap.roze, colorMap.rozeVergrijsd],
  },
  {
    'key': 'geel',
    'label': 'Geel',
    'value': [colorMap.geel, colorMap.geelVergrijsd],
  },
  {
    'key': 'rood',
    'label': 'Rood',
    'value': [colorMap.rood, colorMap.roodVergrijsd],
  },
];


export let colorListCharts = [
  '#00a1cd',
  '#0058b8',
  '#afcb05',
  '#53a31d',
  '#f39200',
  '#af0e80',
  '#ffcc00',
  '#e94c0a'
];



// WEBPACK FOOTER //
// ./src/app/core/color-list.ts